//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Réussir son logo d'entreprise – NANCOMCY",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Le point sur les éléments qui constituent un bon logo. Quelles sont les conditions à remplir pour que votre logo fonctionne ?",
        },
        {
          hid: "og:image",
          property: "og:image",
          content: require("~/assets/img/blog/thumbnail-header-11.jpeg"),
        },
      ],
    };
  },
};
